import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 -960 960 960"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M626-533q22.5 0 38.25-15.75T680-587t-15.75-38.25T626-641t-38.25 15.75T572-587t15.75 38.25T626-533m-292 0q22.5 0 38.25-15.75T388-587t-15.75-38.25T334-641t-38.25 15.75T280-587t15.75 38.25T334-533m146.174 116Q413-417 358.5-379.5T278-280h53q22-42 62.173-65t87.5-23 86.827 23.5T630-280h52q-25-63-79.826-100t-122-37M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-60q142.375 0 241.188-98.812Q820-337.625 820-480t-98.812-241.188T480-820t-241.188 98.812Q140-622.375 140-480t98.812 241.188T480-140" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }